import React, { useCallback } from 'react';
import Table, { Thead, Tbody, Tr } from 'xpi-black-ui/Common/Table';
import Icon from 'xpi-black-ui/Base/Icon';
import WrapperActions, { CustomTh, CustomTd, CustomTooltip, StatusBullet } from './styles';

function UnwindingTable({ onOpenUnwinding, onOpenDetails, data = [] }) {
  const Status = useCallback(({ status }) => (
    <StatusBullet name={status.label}>
      {status.label === 'WaitingPrice' && 'Verificar com a Mesa'}
      {status.label === 'WaitingApprovalConfirmation' && 'Aguardando Aprovação'}

      {status.label === 'Active' && 'Disponível'}
      {status.label === 'PreQuoted' && 'Solicitado'}
      {status.label === 'Quoted' && 'Solicitado'}
      {status.label === 'Requested' && 'Solicitado'}
      {status.label === 'SentToClient' && 'Enviado p/ o Cliente'}
      {status.label === 'Accepted' && 'Aceito'}
      {status.label === 'ReadyForExecution' && 'A Executar'}
      {status.label === 'PendingExecution' && 'Pendente Execução'}
      {status.label === 'PostExecutionCheck' && 'Executado'}
      {status.label === 'PendingRegistration' && 'Pendente Registro'}

      {status.label === 'Registered' && 'Registrado'}
      {status.label === 'Complete' && 'Totalmente Executado'}
      {status.label === 'Canceled' && 'Cancelado'}
      {status.label === 'Unavailable' && 'Indisponível'}
    </StatusBullet>
  ), []);

  return (
    <Table>
      <Thead>
        <Tr align="center">
          {['Ações', 'Status', 'Cliente', 'Ativo', 'Estrutura', 'Quantidade', 'Entrada', 'Encerramento', 'Tempo na Operação',
            'Resultado Bruto Atual (%)', 'Ganho Atual/Ganho Máximo (%)', 'Perform. Ativo (R$)', 'Perform. Estrutura (R$)'].map(columnTitle => (
            <CustomTh key={columnTitle}>
              {columnTitle}
            </CustomTh>
          ))}
        </Tr>
      </Thead>

      <Tbody>
        {data?.map(position => (
          <Tr key={`${position.operationId}`}>
            <CustomTd>
              <WrapperActions>
                <CustomTooltip text={'Antecipar'}>
                  {position.status.label === 'Active' && <Icon type="docOk" onClick={() => onOpenUnwinding(position)} />}
                  {position.status.label !== 'Active' && <span>-</span>}
                </CustomTooltip>
              </WrapperActions>
            </CustomTd>
            <CustomTd>
              <CustomTooltip addBorder={position.status.reason} text={position.status.reason}>
                {<Status status={position.status} />}
              </CustomTooltip>
            </CustomTd>
            <CustomTd>{position.clientId}</CustomTd>
            <CustomTd>{position.asset.ticker}</CustomTd>
            <CustomTd>{position.structure.name}</CustomTd>
            <CustomTd>{position.quantityContracted}</CustomTd>
            <CustomTd>{position.acquisitionDate}</CustomTd>
            <CustomTd>{position.maturityDate}</CustomTd>
            <CustomTd>{position.elapsedOperationTime.inText}</CustomTd>
            <CustomTd>{position.currentPosition.profit.percentage}</CustomTd>
            <CustomTd>{position.currentPosition.profit.onMaxContractedPercentage}</CustomTd>
            <CustomTd>{position.currentPosition.assetPerformanceValue}</CustomTd>
            <CustomTd>{position.currentPosition.profit.withoutAsset}</CustomTd>
        </Tr>
        ))}
      </Tbody>
    </Table>
  );
}

export default React.memo(UnwindingTable);

